<template>
  <!-- 메인 홈 화면 진입할때마다 보이는 전역공지 팝업 -->
  <global-popup
    v-if="isMannedPopup"
    :title="mannedData.title"
    :src="mannedData.src"
    @close="closeMannedPopup()"
    @no-more="closeMannedPopupNoMore()"
  />
  <global-popup
    v-if="isNoticePopup"
    :title="noticeData.title"
    :src="noticeData.src"
    @close="closePopup()"
    @no-more="closePopupNoMore()"
  />
  <div class="flex flex-col gap-40 desktop:gap-60">
    <home-main />
    <home-partners />
    <home-how-to-use />
    <home-benefits />
    <home-banner />
    <home-all-dpost />
    <home-learn-more />
  </div>
</template>

<script lang="ts" setup>
import HomeMain from "@/components/ui/Home/Main.vue";
import HomePartners from "@/components/ui/Home/Partners.vue";
import HomeHowToUse from "@/components/ui/Home/HowToUse.vue";
import HomeBenefits from "@/components/ui/Home/Benefits.vue";
import HomeBanner from "@/components/ui/Home/Banner.vue";
import HomeAllDpost from "@/components/ui/Home/AllDpost/index.vue";
import HomeLearnMore from "@/components/ui/Home/LearnMore.vue";

import globalPopup from "@/components/modal/popup.vue";
import { useMannedPopup, useNoticePopup } from "@/lib/usePopup";

const { isMannedPopup, mannedData, closeMannedPopup, closeMannedPopupNoMore } =
  useMannedPopup("parcel");

//이노텍 파주 세차오픈 안내
const { noticeData, isNoticePopup, closePopup, closePopupNoMore } =
  useNoticePopup();
</script>

<style lang="scss" scoped></style>
